import { checker } from "lib/share/regexOfInput";

const removeDoubleSpace = text => {
  return text && text.replace(/ {2,}/g, " ");
};

const replaceSpaceWithHyphen = text => {
  return (
    text &&
    text
      .replace(/ {2,}/g, " ")
      .trim()
      .replace(/ /g, "-")
  );
};

const getFilteredInput = (type, text) => {
  if (!text) return null;

  const filter = checker.getFilteredValue[type];
  if (!filter) {
    console.log("error");
    console.error("error");
    return null;
  }

  return filter(text);
};

const isValidInput = (type, text) => {
  const validChecker = checker.isValid[type];
  if (!validChecker) {
    console.log("error");
    console.error("error");
    return null;
  }

  return validChecker(text);
};

export {
  getFilteredInput,
  removeDoubleSpace,
  replaceSpaceWithHyphen,
  isValidInput
};
